import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject59() {
  var data = _taggedTemplateLiteral(["\n    padding: 20px;\n  "]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = _taggedTemplateLiteral(["\n  padding: 25px;\n  ", "\n"]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  margin-bottom: 15px;\n"]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = _taggedTemplateLiteral(["\n    height: 159px;\n  "]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = _taggedTemplateLiteral(["\n    height: 239px;\n  "]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = _taggedTemplateLiteral(["\n    height: 318px;\n  "]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: auto;\n  height: auto;\n  max-width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(245, 241, 242, 0.5);\n  mix-blend-mode: multiply;\n  overflow: hidden;\n\n  height: 372px;\n  ", "\n  ", "\n  ", "\n\n  > img {\n    flex-shrink: 0;\n    height: 100%;\n    mix-blend-mode: multiply;\n    display: inline-block !important; \n  }\n"]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 5px;\n    font-size: 10px;\n    text-align: left;\n  "]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n  font-family: Inter;\n  line-height: 160%;\n  color: #4f6e7c;\n  width: 50%;\n  text-align: right;\n  font-size: 18px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    width: 100%;\n  "]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n    font-size: 18px;\n  "]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n    font-size: 20px;\n  "]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n  font-weight: 300;\n  line-height: 100%;\n  color: #2c2c2c;\n  font-family: \"Sofia thin\";\n  text-transform: capitalize;\n\n  width: 50%;\n  text-align: left;\n\n  font-size: 24px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n  background: #f5f1f2;\n  text-align: center;\n  height: 100%;\n  transition: 0.3s;\n  display: flex;\n  flex-direction: column;\n\n  @media (hover: hover) {\n    :hover {\n      background-color: #ffffff;\n      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);\n    }\n  }\n"]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n    margin: 0;\n  "]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n  font-family: Inter;\n  line-height: 19px;\n  color: #839098;\n  text-transform: capitalize;\n  text-align: left;\n  margin-top: 9px;\n  \n  font-size: 16px;\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n    transform: scale(calc(20 / 48)); // 30 9\n  "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n    transform: scale(calc(30 / 48)); // 30 13\n  "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n    transform: scale(calc(40 / 48)); // 40 18\n  "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.3s;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #4f6e7c;\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n\n  transform-origin: 68px 68px;\n  ", "\n  ", "\n  ", "\n  &::after {\n    content: \"\";\n    width: 38%;\n    height: 38%;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n  }\n"]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n    transform: scale(calc(20 / 48)); // 30 9\n    bottom: calc(20px + 18px + 10px);\n  "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n    bottom: calc(20px + 28px + 10px);\n  "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n    bottom: calc(20px + 35px);\n    transform: scale(calc(30 / 48)); // 30 13\n  "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n    bottom: calc(20px + 50px);\n    transform: scale(calc(40 / 48)); // 40 18\n  "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n  transition: 0.3s;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background-color: #4f6e7c;\n  position: absolute;\n  bottom: calc(20px + 48px + 10px);\n  right: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n\n  transform-origin: 68px 68px;\n  ", "\n  ", "\n  ", "\n  ", "\n  &::after {\n    content: \"\";\n    width: 38%;\n    height: 38%;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n  }\n"]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n    padding: 10px;\n    flex-direction: column;\n    align-items: start;\n  "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n    padding: 15px;\n  "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n    padding: 20px;\n  "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n  padding: 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  height: 100%;\n\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n      transform: scale(0.8);\n    "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n    width: 36px;\n  "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 56px;\n  margin-left: 6px;\n  padding: 0 !important;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n  svg {\n    width: 24px;\n    height: 24px;\n    ", "\n  }\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n      transform: scale(0.8);\n    "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n      font-size: 8px;\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n      font-size: 11px;\n      padding: 7px 0px 7px;\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      font-size: 13px;\n      padding: 13px 9px 11px;\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n        margin-left: 5px;\n      "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  display: flex;\n  justify-content: center;\n  flex-grow: 1;\n  span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    > div {\n      margin-left: 10px;\n      ", "\n    }\n  }\n  &.button {\n    font-size: 16px;\n    padding: 16px;\n    ", "\n    ", "\n    ", "\n  }\n  svg {\n    opacity: 0.5;\n    ", "\n    path {\n      stroke: #ffffff;\n    }\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: auto;\n  width: 100%;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  &.show {\n    margin-bottom: 20px;\n  }\n  ", "\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    margin: 3px 0 12px;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    flex-wrap: wrap;\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      display: flex;\n      width: 100%;\n      flex-wrap: wrap;\n      white-space: initial;\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        &:first-child::after {\n          display: none;\n        }\n        &:not(:first-child)::after {\n          display: block;\n        }\n      "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      width:100px;\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      line-height: 160%;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        height: 16px;\n      "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  flex-direction: row-reverse;\n  justify-content: flex-end;\n  margin: 15px 0 20px;\n  ", " {\n    line-height: 20px;\n    display: flex;\n    align-items: center;\n    &:not(:first-child)::after {\n      content: \"\";\n      width: 2px;\n      height: 20px;\n      background-color: #5b6870;\n      opacity: 0.3;\n      display: inline-block;\n      margin: 0 10px;\n      ", "\n    }\n    ", "\n  }\n\n  &.collapsible {\n    display: block;\n    width: 145px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    ", "\n    ", " {\n      display: inline;\n      padding-right: 15px;\n      &:not(:first-child)::after {\n        display: none;\n      }\n      &:first-child::after {\n        content: \"\";\n        width: 2px;\n        height: 20px;\n        background-color: #5b6870;\n        opacity: 0.3;\n        display: inline-block;\n        margin: 0 10px;\n      }\n      ", "\n    }\n    ", "\n  }\n  &.show {\n    display: flex;\n    margin-bottom: 0px;\n    white-space: initial;\n    width: 100%;\n    flex-wrap: wrap;\n    ", " {\n      display: flex;\n      padding-right: 0;\n    }\n  }\n  ", "\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      margin-left: 5px;\n      &:last-child {\n        margin-left: 2px;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 10px;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n  color: #839098;\n  font-size: 16px;\n  line-height: 160%;\n  ", "\n  ", "\n  span {\n    color: #5b6870;\n    margin-left: 10px;\n    &:last-child {\n      margin-left: 3px;\n    }\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 2px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 15px;\n  width: 100%;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import { Button } from "@temp/components";
import garbageImage from "images/garbage.svg";
import pensileImage from "images/pensile.svg";
export var Attributes = styled.ul(_templateObject(), media.mediumScreen(_templateObject2()));
export var Attribute = styled.li(_templateObject3(), media.xxLargeScreen(_templateObject4()), media.mediumScreen(_templateObject5()), media.extraSmallScreen(_templateObject6()));
export var VariantAttributes = styled.ul(_templateObject7(), Attribute, media.mediumScreen(_templateObject8()), media.mediumScreen(_templateObject9()), media.largeScreen(_templateObject10()), Attribute, media.mediumScreen(_templateObject11()), media.mediumScreen(_templateObject12()), Attribute, media.largeScreen(_templateObject13()), media.mediumScreen(_templateObject14()));
export var ShowMoreButton = styled.button(_templateObject15(), media.mediumScreen(_templateObject16()));
export var Buttons = styled.div(_templateObject17());
export var AddButton = styled(Button)(_templateObject18(), media.extraSmallScreen(_templateObject19()), media.xxLargeScreen(_templateObject20()), media.mediumScreen(_templateObject21()), media.smallScreen(_templateObject22()), media.mediumScreen(_templateObject23()));
export var ShareButton = styled(Button)(_templateObject24(), media.mediumScreen(_templateObject25()), media.mediumScreen(_templateObject26()));
export var Bottom = styled.div(_templateObject27(), media.xxLargeScreen(_templateObject28()), media.xLargeScreen(_templateObject29()), media.smallScreen(_templateObject30()));
export var Remove = styled.div(_templateObject31(), media.xxLargeScreen(_templateObject32()), media.xLargeScreen(_templateObject33()), media.largeScreen(_templateObject34()), media.smallScreen(_templateObject35()), garbageImage);
export var Pencil = styled.div(_templateObject36(), media.xxLargeScreen(_templateObject37()), media.xLargeScreen(_templateObject38()), media.smallScreen(_templateObject39()), pensileImage);
export var Category = styled.p(_templateObject40(), media.xxLargeScreen(_templateObject41()), media.xLargeScreen(_templateObject42()), media.smallScreen(_templateObject43()));
export var Wrapper = styled.div(_templateObject44());
export var Title = styled.h4(_templateObject45(), media.xxLargeScreen(_templateObject46()), media.xLargeScreen(_templateObject47()), media.smallScreen(_templateObject48()));
export var Price = styled.p(_templateObject49(), media.xxLargeScreen(_templateObject50()), media.xLargeScreen(_templateObject51()), media.smallScreen(_templateObject52()));
export var Image = styled.div(_templateObject53(), media.xxLargeScreen(_templateObject54()), media.xLargeScreen(_templateObject55()), media.smallScreen(_templateObject56()));
export var AttributesWrapper = styled.div(_templateObject57());
export var Placeholder = styled.div(_templateObject58(), media.smallScreen(_templateObject59()));